// Insurance tab rebuild — insurance-claims transport. Standalone module
// (mirrors client.ts style) so the claims surface ships without touching
// the shared portfolio-admin client. Hooks in
// @/hooks/portfolioAdmin/useInsuranceClaims wrap these with TanStack Query.

import { api } from "../client";

export type InsuranceClaimStatus =
  | "Filed"
  | "Acknowledged"
  | "Adjusting"
  | "Settled"
  | "Denied";

export interface InsuranceClaimDto {
  id: string;
  loanId: string;
  insurancePolicyId: string;
  policyType: string;
  dateOfLoss: string;
  description: string;
  claimNumber: string | null;
  amountClaimed: number | null;
  amountSettled: number | null;
  status: InsuranceClaimStatus;
  filedAt: string;
  acknowledgedAt: string | null;
  adjustingAt: string | null;
  settledAt: string | null;
  deniedAt: string | null;
  notes: string | null;
}

export interface FileInsuranceClaimRequest {
  insurancePolicyId: string;
  /** ISO date (YYYY-MM-DD). */
  dateOfLoss: string;
  description: string;
  claimNumber?: string | null;
  amountClaimed?: number | null;
}

export interface AdvanceInsuranceClaimRequest {
  /** Next legal stage: Filed→Acknowledged→Adjusting→Settled|Denied. */
  status: InsuranceClaimStatus;
  amountSettled?: number | null;
  notes?: string | null;
}

export const insuranceClaimsApi = {
  list: (loanId: string) =>
    api.get<InsuranceClaimDto[]>(
      `/portfolio-admin/loans/${loanId}/insurance-claims`,
    ),
  file: (loanId: string, body: FileInsuranceClaimRequest) =>
    api.post<InsuranceClaimDto>(
      `/portfolio-admin/loans/${loanId}/insurance-claims`,
      body,
    ),
  advance: (claimId: string, body: AdvanceInsuranceClaimRequest) =>
    api.post<InsuranceClaimDto>(
      `/portfolio-admin/insurance-claims/${claimId}/advance`,
      body,
    ),
};
